// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e0f8225d","513":"44d25642","703":"67109820","787":"d1cdcb86"}[chunkId] + ".chunk.js";
};